import { ReactiveFormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemSliderComponent } from './item-slider/item-slider.component';
import { SwiperModule } from 'swiper/angular';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from './loader/loader/loader.component';
import { LiveAuctionComponent } from './live-auction/live-auction.component';
import { AuctionCardComponent } from './auction-card/auction-card.component';
import { TableContentComponent } from './table-content/table-content.component';
import { DataTablesModule } from 'angular-datatables';
import { LaddaModule } from 'angular2-ladda';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { BackButtonComponent } from './back-button/back-button.component';
import { InputMaskModule } from '@ngneat/input-mask';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuctionDetailsHeroSkeletonComponent } from './auction-details-hero-skeleton/auction-details-hero-skeleton.component';
import { AuctionVehicleCardComponent } from './auction-vehicle-card/auction-vehicle-card.component';
import { TimedIndividualAuctionDetailsComponent } from './timed-individual-auction-details/timed-individual-auction-details.component';
import { CutomLoaderComponent } from './loader/cutom-loader/cutom-loader.component';
import { InputLoaderComponent } from './input-loader/input-loader.component';
import { DownArrowComponent } from './down-arrow/down-arrow.component';
import { InfiniteScrollComponentComponent } from './infinite-scroll-component/infinite-scroll-component.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ConfirmSoldModalComponent } from './confirm-sold-modal/confirm-sold-modal.component';
import { CreateSalvageAuctionComponent } from './create-salvage-auction/create-salvage-auction.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { SalvageInventoryTabComponent } from './salvage-auction/salvage-inventory-tab/salvage-inventory-tab.component';
import { SalvageOngoingTabComponent } from './salvage-auction/salvage-ongoing-tab/salvage-ongoing-tab.component';
import { SalvageBuyNowTabComponent } from './salvage-auction/salvage-buy-now-tab/salvage-buy-now-tab.component';
import { SalvageInCartTabComponent } from './salvage-auction/salvage-in-cart-tab/salvage-in-cart-tab.component';
import { SalvagePendingPaymentsTabComponent } from './salvage-auction/salvage-pending-payments-tab/salvage-pending-payments-tab.component';
import { SalvageCompletedPaymentsTabComponent } from './salvage-auction/salvage-completed-payments-tab/salvage-completed-payments-tab.component';
import { SalvageClosedTabComponent } from './salvage-auction/salvage-closed-tab/salvage-closed-tab.component';
import { SalvageExpiredInvoicesTabComponent } from './salvage-auction/salvage-expired-invoices-tab/salvage-expired-invoices-tab.component';
import { SalvageAllAuctionsTabComponent } from './salvage-auction/salvage-all-auctions-tab/salvage-all-auctions-tab.component';
import { SalvageNotActiveTabComponent } from './salvage-auction/salvage-not-active-tab/salvage-not-active-tab.component';
import { SalvageUpcomingTabComponent } from './salvage-auction/salvage-upcoming-tab/salvage-upcoming-tab.component';

@NgModule({
  declarations: [
    ItemSliderComponent,
    LoaderComponent,
    LiveAuctionComponent,
    AuctionCardComponent,
    TableContentComponent,
    BackButtonComponent,
    AuctionDetailsHeroSkeletonComponent,
    AuctionVehicleCardComponent,
    TimedIndividualAuctionDetailsComponent,
    CutomLoaderComponent,
    InputLoaderComponent,
    DownArrowComponent,
    InfiniteScrollComponentComponent,
    ConfirmSoldModalComponent,
    CreateSalvageAuctionComponent,
    SalvageInventoryTabComponent,
    SalvageOngoingTabComponent,
    SalvageBuyNowTabComponent,
    SalvageInCartTabComponent,
    SalvagePendingPaymentsTabComponent,
    SalvageCompletedPaymentsTabComponent,
    SalvageClosedTabComponent,
    SalvageExpiredInvoicesTabComponent,
    SalvageAllAuctionsTabComponent,
    SalvageNotActiveTabComponent,
    SalvageUpcomingTabComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SwiperModule,
    DataTablesModule,
    ReactiveFormsModule,
    LaddaModule.forRoot({
      style: 'slide-up',
      spinnerSize: 30,
      spinnerColor: '#F9B22C',
      spinnerLines: 1,
    }),
    TabsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxMaterialTimepickerModule,
    InputMaskModule.forRoot({ inputSelector: 'input', isAsync: true }),
    NgSelectModule,
    InfiniteScrollModule, // 👈 Add this
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
  ],
  exports: [
    ItemSliderComponent,
    LoaderComponent,
    LiveAuctionComponent,
    AuctionCardComponent,
    TableContentComponent,
    BackButtonComponent,
    AuctionDetailsHeroSkeletonComponent,
    AuctionVehicleCardComponent,
    TimedIndividualAuctionDetailsComponent,
    CutomLoaderComponent,
    InputLoaderComponent,
    DownArrowComponent,
    InfiniteScrollComponentComponent,
    ConfirmSoldModalComponent,
    CreateSalvageAuctionComponent,
    SalvageInventoryTabComponent,
    SalvageOngoingTabComponent,
    SalvageBuyNowTabComponent,
    SalvageInCartTabComponent,
    SalvagePendingPaymentsTabComponent,
    SalvageCompletedPaymentsTabComponent,
    SalvageClosedTabComponent,
    SalvageExpiredInvoicesTabComponent,
    SalvageAllAuctionsTabComponent,
    SalvageNotActiveTabComponent,
    SalvageUpcomingTabComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule {}
